// Elegant section separator: two thin gold lines with a centered diamond/dot mark.
// Adapts to any background — uses currentColor with muted opacity so it works on light + dark.
const SectionDivider = ({ dark = false }) => {
  const line = dark ? "bg-white/15" : "bg-ink/10";
  const dot = "bg-gold";
  return (
    <div
      aria-hidden="true"
      className={`${dark ? "bg-ink" : "bg-white"} flex items-center justify-center py-2`}
      data-testid="section-divider"
    >
      <div className="flex items-center gap-4 w-full max-w-md px-8">
        <span className={`flex-1 h-px ${line}`} />
        <span className={`w-1.5 h-1.5 rotate-45 ${dot}`} />
        <span className={`flex-1 h-px ${line}`} />
      </div>
    </div>
  );
};

export default SectionDivider;
